var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-group',[_c('v-group',{attrs:{"config":{ x: _vm.left, y: _vm.top }}},[_c('v-image',{attrs:{"id":"okleina","config":{
    y: -_vm.top / 4,
    width: _vm.width,
    height: _vm.height - 3,
    image: _vm.okleinaimage,
    crop: { width: _vm.width * 3, height: _vm.height * 3, x: 500, y: 10 },
  }}}),(
    _vm.mixbool &&
    this.wzor != 'FL1' &&
    this.wzor != 'FL1A' &&
    this.wzor != 'FL2'
  )?_c('v-image',{attrs:{"id":"mixokleina","config":{
    y: -3,
    width: _vm.mixcCorrectWidth,
    height: _vm.height - 3,
    x: _vm.mixcCorrectX - 6,
    image: _vm.okleinaimage2,
    crop: { width: _vm.mixc.width * 3, height: _vm.height * 3, x: 500, y: 10 },
  }}}):_vm._e(),(
    this.lamele == 'J' &&
    this.wzor == '01' &&
    this.kierunek.indexOf('w') >= 0 &&
    _vm.selectedwidok == 'Z'
  )?_c('v-group',[_vm._l((this.lameleilosc),function(i){return _c('v-image',{key:i + 'l',attrs:{"id":"lamele","config":{
      y: -3,
      width: 41 / 4,
      height: _vm.height - 5,
      x: 15 / 4 + (56 * (i - 1)) / 4,
      image: _vm.lameleimage,
      crop: {
        width: (41 / 4) * 3,
        height: _vm.height * 3,
        x: 500 + 100 * Math.random() * 13,
        y: 10,
      },
    }}})}),_vm._l((this.lameleilosc),function(i){return _c('v-rect',{key:i,attrs:{"id":"Obramówka","config":{
      y: -3,
      width: 41 / 4,
      height: _vm.height - 5,
      x: 15 / 4 + (56 * (i - 1)) / 4,
      stroke: '#222',
      strokeWidth: 0.75,
    }}})})],2):_vm._e(),(this.wzor == '3D3')?_c('v-group',_vm._l((13),function(i){return _c('v-image',{key:i,attrs:{"id":"3D3","config":{
      image: _vm.lameleimage,
      x: 100 / 4,
      width: 600 / 4,
      height: 8 / 4,
      y: 100 / 4 + (147.5 * (i - 1)) / 4,
      stroke: '#222',
      strokeWidth: 0.25,
      crop: { width: (600 / 4) * 3, height: (8 / 4) * 3, x: 0, y: 100 },
    }}})}),1):_vm._e(),(this.wzor == '3D4')?_c('v-group',_vm._l((7),function(i){return _c('v-image',{key:i,attrs:{"id":"3D4","config":{
      image: _vm.lameleimage,
      x: 68 / 4 + (78 * (i - 1)) / 4,
      width: 8 / 4,
      height: 1880 / 4,
      y: 49 / 4,
      stroke: '#222',
      strokeWidth: 0.25,
      crop: { width: (8 / 4) * 3, height: (1880 / 4) * 3, x: 0, y: 100 },
    }}})}),1):_vm._e(),(this.wzor == '3D6')?_c('v-group',[_vm._l((4),function(i){return _c('v-image',{key:'line1'+i,attrs:{"config":{
        image: _vm.lameleimage,
        width: 8/4,
        height: 461/4 + (i-1)*30/4,
        stroke: '#222',
        // fill: '#222',
        strokeWidth: .25,
        x: (_vm.width - 736/4)/2 + (i-1)*30/4,
        Y: (_vm.height-_vm.top - 1826/4)/2 + (i-1)*30/4,
        crop: { width: (8 / 4) * 3, height: (461 / 4) * 3, x: 0, y: 100 },
      }}})}),_vm._l((4),function(i){return _c('v-image',{key:'line11'+i,attrs:{"config":{
        image: _vm.lameleimage,
        height: 8/4,
        width: 461/4 + (i-1)*30/4,
        stroke: '#222',
        // fill: '#222',
        strokeWidth: .25,
        x: (_vm.width - 736/4)/2 + (i-1)*30/4,
        Y: (_vm.height-_vm.top - 1826/4)/2 + (i-1)*30/4,
        crop: { width: (8 / 4) * 3, height: (461 / 4) * 3, x: 0, y: 100 },
      }}})}),_vm._l((4),function(i){return _c('v-image',{key:'line2'+i,attrs:{"config":{
        image: _vm.lameleimage,
        scaleX: -1,
        width: 8/4,
        height: -461/4 - (i-1)*30/4,
        stroke: '#222',
        fill: '#222',
        strokeWidth: .25,
        x: _vm.width-(_vm.width - 736/4)/2 - (i-1)*30/4,
        Y: _vm.height-_vm.top-(_vm.height-_vm.top - 1826/4)/2 - (i-1)*30/4,
        crop: { width: (8 / 4) * 3, height: (461 / 4) * 3, x: 0, y: 100 },
      }}})}),_vm._l((4),function(i){return _c('v-image',{key:'line22'+i,attrs:{"config":{
        image: _vm.lameleimage,
        scaleX: -1,
        scaleY: -1,
        height: 8/4,
        width: 461/4 + (i-1)*30/4,
        stroke: '#222',
        fill: '#222',
        strokeWidth: .25,
        x: _vm.width-(_vm.width - 736/4)/2 - (i-1)*30/4,
        Y: _vm.height-_vm.top-(_vm.height-_vm.top - 1826/4)/2 - (i-1)*30/4,
        crop: { width: (8 / 4) * 3, height: (461 / 4) * 3, x: 0, y: 100 },
      }}})}),_vm._l((4),function(i){return _c('v-image',{key:'3D6x'+i,attrs:{"config":{
      image: _vm.lameleimage,
      x: (68+350 + (30 * (i - 1))) / 4,
      width: 8 / 4,
      height: 553 / 4,
      y: (75+560+(50 * (i - 1))) / 4,
      stroke: '#222',
      strokeWidth: 0.25,
      crop: { width: (8 / 4) * 3, height: (461 / 4) * 3, x: 0, y: 100 },
    }}})})],2):_vm._e(),(this.wzor == '3D7' || this.wzor == '3D8')?_c('v-group',[_vm._l((4),function(i){return _c('v-image',{key:'line17'+i,attrs:{"config":{
        image: _vm.lameleimage,
        width: 8/4,
        height: 461/4 + (i-1)*30/4 +(i==1?210/4:0),
        stroke: '#222',
        // fill: '#222',
        strokeWidth: .25,
        x: (_vm.width - 736/4)/2 + (i-1)*30/4,
        Y: (_vm.height-_vm.top - 1826/4)/2 + (i-1)*30/4,
        crop: { width: (8 / 4) * 3, height: (461 / 4) * 3, x: 0, y: 100 },
      }}})}),_vm._l((4),function(i){return _c('v-image',{key:'line171'+i,attrs:{"config":{
        image: _vm.lameleimage,
        height: 8/4,
        width: 461/4 + (i-1)*30/4 +(i==1?210/4:0),
        stroke: '#222',
        // fill: '#222',
        strokeWidth: .25,
        x: (_vm.width - 736/4)/2 + (i-1)*30/4,
        Y: (_vm.height-_vm.top - 1826/4)/2 + (i-1)*30/4,
        crop: { width: (8 / 4) * 3, height: (461 / 4) * 3, x: 0, y: 100 },
      }}})})],2):_vm._e(),(this.wzor == '3D7')?_c('v-group',[_vm._l((4),function(i){return _c('v-image',{key:'line27'+i,attrs:{"config":{
        image: _vm.lameleimage,
        scaleX: -1,
        width: 8/4,
        height: -461/4 - (i-1)*30/4 -(i==1?210/4:0),
        stroke: '#222',
        fill: '#222',
        strokeWidth: .25,
        x: _vm.width-(_vm.width - 736/4)/2 - (i-1)*30/4,
        Y: _vm.height-_vm.top-(_vm.height-_vm.top - 1826/4)/2 - (i-1)*30/4,
        crop: { width: (8 / 4) * 3, height: (461 / 4) * 3, x: 0, y: 100 },
      }}})}),_vm._l((4),function(i){return _c('v-image',{key:'line272'+i,attrs:{"config":{
        image: _vm.lameleimage,
        scaleX: -1,
        scaleY: -1,
        height: 8/4,
        width: 461/4 + (i-1)*30/4 +(i==1?210/4:0),
        stroke: '#222',
        fill: '#222',
        strokeWidth: .25,
        x: _vm.width-(_vm.width - 736/4)/2 - (i-1)*30/4,
        Y: _vm.height-_vm.top-(_vm.height-_vm.top - 1826/4)/2 - (i-1)*30/4,
        crop: { width: (8 / 4) * 3, height: (461 / 4) * 3, x: 0, y: 100 },
      }}})})],2):_vm._e(),(this.wzor == '3D5')?_c('v-group',[_vm._l((1),function(i){return _c('v-image',{key:'3D5'+i,attrs:{"config":{
      image: _vm.lameleimage,
      x: 68 / 4 + (78 * (i - 1)) / 4,
      width: 8 / 4,
      height: 1096 / 4,
      y: 75 / 4,
      stroke: '#222',
      strokeWidth: 0.25,
      crop: { width: (8 / 4) * 3, height: (1096 / 4) * 3, x: 0, y: 100 },
    }}})}),_vm._l((1),function(i){return _c('v-image',{key:'3D52'+i,attrs:{"config":{
      image: _vm.lameleimage,
      x: 68 / 4 + (78 * (i - 1)) / 4,
      width: 8 / 4,
      height: 370 / 4,
      y: (75+1096+370) / 4,
      stroke: '#222',
      strokeWidth: 0.25,
      crop: { width: (8 / 4) * 3, height: (370 / 4) * 3, x: 0, y: 100 },
    }}})}),_vm._l((1),function(i){return _c('v-image',{key:'3D53'+i,attrs:{"config":{
      image: _vm.lameleimage,
      x: (68+75) / 4 + (78 * (i - 1)) / 4,
      width: 8 / 4,
      height: 370 / 4,
      y: 75 / 4,
      stroke: '#222',
      strokeWidth: 0.25,
      crop: { width: (8 / 4) * 3, height: (370 / 4) * 3, x: 0, y: 100 },
    }}})}),_vm._l((1),function(i){return _c('v-image',{key:'3D56'+i,attrs:{"config":{
      image: _vm.lameleimage,
      x: (68+75) / 4 + (78 * (i - 1)) / 4,
      width: 8 / 4,
      height: 1096 / 4,
      y: (75+370+370) / 4,
      stroke: '#222',
      strokeWidth: 0.25,
      crop: { width: (8 / 4) * 3, height: (1096 / 4) * 3, x: 0, y: 100 },
    }}})}),_vm._l((1),function(i){return _c('v-image',{key:'3D54'+i,attrs:{"config":{
      image: _vm.lameleimage,
      x: (68+75*2) / 4 + (78 * (i - 1)) / 4,
      width: 8 / 4,
      height: 678 / 4,
      y: 75 / 4,
      stroke: '#222',
      strokeWidth: 0.25,
      crop: { width: (8 / 4) * 3, height: (678 / 4) * 3, x: 0, y: 100 },
    }}})}),_vm._l((1),function(i){return _c('v-image',{key:'3D55'+i,attrs:{"config":{
      image: _vm.lameleimage,
      x: (68+75*2) / 4 + (78 * (i - 1)) / 4,
      width: 8 / 4,
      height: 678 / 4,
      y: (75+678+470) / 4,
      stroke: '#222',
      strokeWidth: 0.25,
      crop: { width: (8 / 4) * 3, height: (678 / 4) * 3, x: 0, y: 100 },
    }}})})],2):_vm._e(),(this.wzor == '3D2')?_c('v-group',[_vm._l((9),function(i){return _c('v-image',{key:i,attrs:{"id":"3D2","config":{
      x: 72 / 4 + (45 * (i - 1)) / 4,
      width: 8 / 4,
      height: 1920 / 4 - (45 * (i - 1)) / 4,
      y: 49 / 4 + (45 * (i - 1)) / 4,
      stroke: '#222',
      strokeWidth: 0.25,
      image: _vm.lameleimage,
    }}})}),_vm._l((9),function(i){return _c('v-image',{key:'3D2' + i,attrs:{"id":"3D22","config":{
      x: 72 / 4 + (45 * (i - 1)) / 4,
      width: _vm.width - 156 / 4 - (45 * (i - 1)) / 4,
      height: 8 / 4,
      y: 49 / 4 + (45 * (i - 1)) / 4,
      stroke: '#222',
      strokeWidth: 0.25,
      image: _vm.lameleimage,
    }}})})],2):_vm._e(),_c('v-image',{attrs:{"id":"szyba2","config":{ y: -3, width: _vm.width, height: _vm.height - 3, image: _vm.szybaimage2 }}}),_c('v-image',{attrs:{"id":"szyba","config":{ y: -3, width: _vm.width, height: _vm.height - 3, image: _vm.szybaimage }}}),(this.wzor.includes('WL'))?_c('v-image',{attrs:{"id":"lameleWood","config":{ y: -3, width: _vm.width, height: _vm.height - 3, image: _vm.lameleWood }}}):_vm._e(),(
    (this.selectedwidok != 'Z' &&
      (this.activeModel.typ == 'GD' ||
        this.activeModel.typ == 't' ||
        this.activeModel.typ == 'n')) ||
    (this.activeModel.typ != 'GD' &&
      !['12A', '12B', '12C', '3D3', '3D4', '3D2', '3D1'].includes(
        this.wzor
      ))
  )?_c('v-image',{attrs:{"id":"tloczenie","config":{
    y: -3,
    width: _vm.width,
    height: _vm.height - 3,

    // opacity:this.kolor2typ=='DEK' && !['01','02','03','13','15','17'].includes(this.kolor) && ['INOX','PCV','GF','GL'].includes(this.activeModel.typ) && this.activeModel.tloczenie?.25:1,
    image: _vm.tloczenieimage,
  }}}):_vm._e(),(
    this.wzor == '12A' ||
    this.wzor == '12B' ||
    this.wzor == '12C'
  )?_c('v-image',{attrs:{"id":"tloczenie","config":{
    y: -3,
    width: _vm.width,
    height: _vm.height - 3,
    image: _vm.tloczenieimage,
  }}}):_vm._e(),(this.activeModel.typ == 'INOX')?_c('v-image',{attrs:{"id":"tloczeniex","config":{
    y: -3,
    width: _vm.width,
    height: _vm.height - 3,
    image: _vm.tloczenieimagex,

  }}}):_vm._e(),(this.activeModel.typ == 'MG' || this.wzor == '51')?_c('v-image',{attrs:{"id":"3d","config":{
    y: -_vm.top / 4,
    width: _vm.width,
    height: _vm.height - 3,
    image: _vm.tloczenieimage3d,
  }}}):_vm._e(),(this.wzor == '3D1')?_c('v-group',_vm._l((this.linie),function(linia){return _c('v-group',{key:linia.linia},[_c('v-image',{attrs:{"config":{
        x: (56 + (linia.linia - 1) * 29.7) / 4,
        width: 8 / 4,
        height: linia.h1 / 4,
        y: linia.gora / 4,
        stroke: '#222',
        strokeWidth: 0.25,
        image: _vm.lameleimage,
      }}}),_c('v-image',{attrs:{"config":{
        x: (56 + (linia.linia - 1) * 29.7) / 4,
        width: 8 / 4,
        height: linia.h2 / 4,
        y: (linia.gora + linia.h1 + linia.o1) / 4,
        stroke: '#222',
        strokeWidth: 0.25,
        image: _vm.lameleimage,
      }}}),(linia.h3)?_c('v-image',{attrs:{"config":{
        x: (56 + (linia.linia - 1) * 29.7) / 4,
        width: 8 / 4,
        height: linia.h3 / 4,
        y: (linia.gora + linia.h1 + linia.o1 + linia.h2 + linia.o2) / 4,
        stroke: '#222',
        strokeWidth: 0.25,
        image: _vm.lameleimage,
      }}}):_vm._e(),(linia.h4)?_c('v-image',{attrs:{"config":{
        x: (56 + (linia.linia - 1) * 29.7) / 4,
        width: 8 / 4,
        height: linia.h4 / 4,
        y:
          (linia.gora +
            linia.h1 +
            linia.o1 +
            linia.h2 +
            linia.o2 +
            linia.h3 +
            linia.o3) /
          4,
        stroke: '#222',
        strokeWidth: 0.25,
        image: _vm.lameleimage,
      }}}):_vm._e()],1)}),1):_vm._e(),(
    (this.selectedwidok == 'Z' && this.kopniak == '2') ||
    (this.selectedwidok == 'W' && this.kopniak == '1') ||
    this.kopniak == '3'
  )?_c('v-image',{attrs:{"id":"tloczeniee","config":{ y: -6, width: _vm.width, height: _vm.height, image: _vm.tloczenieimagee }}}):_vm._e(),(this.selectedwidok == 'Z' && this.automatyka != '-')?_c('v-image',{attrs:{"id":"automatyka","config":{ width: _vm.width, height: _vm.height, image: _vm.automatykaImage }}}):_vm._e(),_c('v-group',[(_vm.duomaster=='J' && _vm.selectedwidok=='Z' && ['ML02','ML03'].includes(_vm.wzor))?_c('v-image',{attrs:{"id":"lamele","config":{
      y: -3,
      width: 300 / 4,
      height: _vm.height-4,
      x: _vm.width - (300 / 4),
      stroke: '#222',
      strokeWidth: 0.75,
      image: _vm.lameleimage,
      crop: {
        width: (300 / 4) * 3,
        height: _vm.height * 3,
        x: 500 + 100 * Math.random() * 13,
        y: 10,
      },
    }}}):_vm._e(),(['ML02','ML03'].includes(this.wzor))?_c('v-rect',{attrs:{"id":"ramka","config":{width: (this.wzor=='ML02'?240:150)/4, height: _vm.height-5, fill: this.inoxkolor=='10301'?'#CFD4D9':'#222', stroke: '#222', strokeWidth: 0.2, x: ((this.ilelameli*53)+4)/4 /*+(762-240+5)/4*/, y: -2 }}}):_vm._e(),(['ML02','ML03'].includes(this.wzor))?_c('v-image',{attrs:{"id":"szyba2","config":{width: (this.wzor=='ML02'?150:60)/4, height: 1560/4, stroke: '#222', strokeWidth: 0.2, x: ((this.ilelameli*53)+4+45)/4, y: -3+180/4 ,image: _vm.szybaMaster
    ,crop: { width: (this.wzor=='ML02'?150:60), height: _vm.height * 2, x: 500, y: 500 }}}}):_vm._e(),_vm._l((this.ilelameli),function(i){return (_vm.selectedwidok=='Z' ||(_vm.lamobustr=='J' && _vm.selectedwidok=='W' && _vm.wzor=='ML01'))?_c('v-image',{key:i + 'l',attrs:{"id":"lamele","config":{
      y: -1,
      width: 45 / 4,
      height: _vm.height - 7,
      x: 5 / 4 + (53 * (i - 1)) / 4,
      stroke: '#222',
      strokeWidth: 0.75,
      image: _vm.lameleimage,
      crop: {
        width: (41 / 4) * 3,
        height: _vm.height * 3,
        x: 500 + 100 * Math.random() * 13,
        y: 10,
      },
    }}}):_vm._e()})],2),_c('v-image',{attrs:{"id":"klamka","config":{
    y: _vm.korektay / 4,
    width: _vm.width,
    height: _vm.height,
    image: _vm.klamkaimage,
  }}}),(this.seria != '41')?_c('v-image',{attrs:{"id":"rozeta górna","config":{ y: 0 / 4, width: _vm.width, height: _vm.height, image: _vm.rozetaimage }}}):_vm._e(),(
    (this.sposobotw == 'KP' &&
      (this.klamkaWew == 'Lava' || this.selectedwidok == 'Z')) ||
    this.sposobotw == 'PP'
  )?_c('v-image',{attrs:{"id":"rozeta dolna","config":{
    y: 0 / 4,
    width: _vm.width,
    height: _vm.height,
    image: _vm.rozetaimagedol,
  }}}):_vm._e(),_c('v-image',{attrs:{"id":"zawiasy","config":{
    x: -8,
    y: 0 / 4,
    width: _vm.width,
    height: _vm.height,
    image: _vm.zawiasyimage,
  }}}),_c('v-image',{attrs:{"id":"klamka3","config":{ y: 0 / 4, width: _vm.width, height: _vm.height, image: _vm.klamkaimage3 }}}),_c('v-image',{attrs:{"id":"klamka4","config":{ y: 0 / 4, width: _vm.width, height: _vm.height, image: _vm.klamkaimage4 }}}),(this.progled && this.selectedwidok == 'Z')?_c('v-image',{attrs:{"id":"prog_led","config":{ y: 0 / 4, width: _vm.width, height: _vm.height, image: _vm.prog_led }}}):_vm._e(),_c('v-rect',{attrs:{"config":{
    width: _vm.width,
    height: _vm.height - 3,
    stroke: '#222',
    strokeWidth: 0.5,
    x: 0,
    y: -_vm.top / 4,
  }}}),(
    this.sposobotw != 'KK' &&
    this.sposobotw != 'KG' &&
    _vm.selectedwidok == 'Z'
  )?_c('v-image',{attrs:{"id":"Pierścień","config":{ y: 0 / 4, width: _vm.width, height: _vm.height, image: _vm.klamkaimage5 }}}):_vm._e(),_c('v-rect',{attrs:{"id":"Obramówka","config":{
    width: _vm.width,
    height: _vm.height + 3,
    opacity: 0.17,
    fill: '#fff',
    x: 0,
    y: -_vm.top / 4,
    strokeWidth: 0.75,
    stroke: 'black',
  }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }